import React, { Component } from 'react'
import GoogleTagManager from 'gtm'

import MenuOffCanvas from 'components/MenuOffCanvas'
import Header from 'components/Header'
import ContentPanelsDevelopmentMethodology from 'modules/PanelsDevelopmentMethodology'
import Footer from 'components/Footer'

import SurveyControllerContainer from 'modules/Controllers/Survey/SurveyControllerContainer'
import HTMLTitleController from 'modules/Controllers/HTMLTitle/HTMLTitleController'

class PanelsDevelopmentMethodology extends Component {
  render() {
    return (
      <div className="App">
        <GoogleTagManager gtmId="GTM-NXH8F9G" />
        <SurveyControllerContainer />
        <MenuOffCanvas />
        <Header />
        <ContentPanelsDevelopmentMethodology />
        <Footer />
        <HTMLTitleController />
      </div>
    )
  }
}

export default PanelsDevelopmentMethodology



// WEBPACK FOOTER //
// ./src/pages/PanelsDevelopmentMethodology/PanelsDevelopmentMethodology.jsx